import { render, staticRenderFns } from "./QuestionsFilter.vue?vue&type=template&id=071f2f8a&"
import script from "./QuestionsFilter.vue?vue&type=script&lang=js&"
export * from "./QuestionsFilter.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsFilter.vue?vue&type=style&index=0&id=071f2f8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports